(function() {
    'use strict';

    angular
        .module('quilinkApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'duScroll',
            'angularMoment',
            'angular.filter',
            'cgBusy',
            'chart.js',
            'ds.objectDiff',
            'angular-clipboard'
        ])
        .config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
            cfpLoadingBarProvider.spinnerTemplate = '';
          }])
        .config(['ChartJsProvider', function (ChartJsProvider) {
            // Configure all charts
            ChartJsProvider.setOptions({
                colors: ['#97BBCD', '#DCDCDC', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'],
                responsive: false
            });
        }])
        .run(run)
        .value('duScrollBottomSpy', true) // make the last du-scrollspy link active when scroll reaches page/container bottom
        .value('cgBusyDefaults',{
          message:'Loading Stuff',
          templateUrl: 'cgbusy.html'
        });

    run.$inject = ['stateHandler', '$rootScope', '$state', 'amMoment'];

    function run(stateHandler, $rootScope, $state, amMoment) {
        stateHandler.initialize();
        amMoment.changeLocale('fr', {
            relativeTime : {
                future: "dans %s",
                past:   "il y a %s",
                s:  "quelques secondes",
                ss : "%d secondes",
                m:  "une minute",
                mm: "%d minutes",
                h:  "une heure",
                hh: "%d heures",
                d:  "un jour",
                dd: "%d jours",
                M:  "un mois",
                MM: "%d mois",
                y:  "un an",
                yy: "%d ans"
            }
        });

        $rootScope.$on('$stateChangeStart', function (evt, to, params) {
            if (to.redirectTo) {
                evt.preventDefault();
                $state.go(to.redirectTo, params, {location: 'replace'});
            }
        });
    }
})();
